import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import NavigationButtons from 'apps/employer_renewals/components/NavigationButtons'
import Timeline, { type TimelineItem } from 'apps/employer_renewals/components/timeline/Timeline'
import useAppNavigation from 'apps/employer_renewals/hooks/useAppNavigation'
import { useHasFinalizedPricing } from 'apps/employer_renewals/providers/EmployerProvider'
import { EmployerRenewalsRoute } from 'apps/employer_renewals/routes'

type PageCopy = {
  heading: string
  subheadings: string[]
  timelineItems: TimelineItem[]
}

const preliminaryCopy: PageCopy = {
  heading: "Here's what to expect for your 2026 renewal",
  subheadings: [
    'Insurance carriers publish estimated pricing for 2026 individual health insurance plans before their final pricing is confirmed later in October.',
  ],
  timelineItems: [
    {
      title: 'Today',
      body: 'Review your estimated 2026 costs and adjust your allowance strategy.',
      isActive: true,
    },
    {
      title: 'Before Nov 4',
      body: "We'll let you know once your team's rates are finalized, but every state will vary.",
    },
    {
      title: 'Nov 4',
      body: 'Your last day to review and confirm your 2026 allowance strategy.',
    },
    {
      title: 'Nov 5 - Nov 30',
      body: 'Open Enrollment begins for 2026. Your employees will be invited to start choosing their plans, and coverage will begin Jan 1.',
    },
  ],
}

const finalizedCopy: PageCopy = {
  heading: "Here's what to expect for your 2026 renewal",
  subheadings: [
    "You'll need to confirm your 2026 allowance strategy before your employees can choose their plans for 2026",
  ],
  timelineItems: [
    {
      title: 'Today - Nov 4',
      body: 'Review your estimated 2026 costs and adjust your allowance strategy.',
      isActive: true,
    },
    {
      title: 'Nov 5 - Nov 30',
      body: 'Open Enrollment begins for 2026. Your employees will be invited to start choosing their plans, and coverage will begin Jan 1.',
    },
  ],
}

export default function WhatToExpectPage () {
  const { navigateTo } = useAppNavigation()
  const hasFinalizedPricing = useHasFinalizedPricing()

  const pageCopy = hasFinalizedPricing ? finalizedCopy : preliminaryCopy

  return (
    <PageContainer verticallyCentered>
      <Header
        heading={pageCopy.heading}
        subheading={pageCopy.subheadings}
      />
      <div className='max-w-[21.25rem] self-center'>
        <Timeline
          items={pageCopy.timelineItems}
        />
      </div>
      <NavigationButtons
        nextButtonText="I understand, let's continue"
        onNext={() => { navigateTo(EmployerRenewalsRoute.EMPLOYEES_HEADCOUNT) }}
      />
    </PageContainer>
  )
}
